import {Amplify} from 'aws-amplify';

Amplify.configure({

});

export default Amplify;
